"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.timestamp = void 0;

var timestamp = function timestamp(label) {
  var _console, _console$timeStamp;

  return (_console = console) === null || _console === void 0 ? void 0 : (_console$timeStamp = _console.timeStamp) === null || _console$timeStamp === void 0 ? void 0 : _console$timeStamp.call(_console, label);
};

exports.timestamp = timestamp;
